export const hideExportButtons = (accessibleFeatures = []) => {
  if (accessibleFeatures.includes("report-edit")) return true
  if (accessibleFeatures.includes("report-view")) return true

  return false
}
